import { z } from "zod";
import { CorrelationIdSchema, TraceIdSchema } from "../primitives/ids.js";
/** End-to-end trace propagation (D-033). */
export const TraceContextSchema = z.object({
    traceId: TraceIdSchema,
    correlationId: CorrelationIdSchema.optional(),
});
//# sourceMappingURL=trace.js.map